import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import NotFound from '../container/auth/NotFound';

import WithMainLayoutHOC from '../hocs/router/main';
import WithAuthLayoutHOC from '../hocs/router/auth';

import { routesAuth, routesMain } from './data';

const router = createBrowserRouter([
  ...routesAuth?.map(item => ({
    path: item?.path,
    element: (
      <WithAuthLayoutHOC>
        <item.component />
      </WithAuthLayoutHOC>
    )
  })),
  ...routesMain?.map((item, index) => ({
    key: index + 1,
    path: item?.path,
    element: (
      <WithMainLayoutHOC>
        <item.component />
      </WithMainLayoutHOC>
    )
  })),
  {
    path: '*',
    element: (
      <WithAuthLayoutHOC>
        <NotFound />
      </WithAuthLayoutHOC>
    )
  }
]);

const Router = () => {
  return <RouterProvider router={router} />;
};

export default Router;
